import { render, staticRenderFns } from "./SupportTabs.vue?vue&type=template&id=626b8830&"
import script from "./SupportTabs.vue?vue&type=script&lang=ts&"
export * from "./SupportTabs.vue?vue&type=script&lang=ts&"
import style0 from "./SupportTabs.vue?vue&type=style&index=0&id=626b8830&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports